/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicServiceNowChangeStatusTracker extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicServiceNowChangeStatusTracker");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicServiceNowChangeStatusTracker.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicServiceNowChangeStatusTracker>): BackgroundJobPayloadForPeriodicServiceNowChangeStatusTracker {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicServiceNowChangeStatusTracker(), model);
        BackgroundJobPayloadForPeriodicServiceNowChangeStatusTracker.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicServiceNowChangeStatusTracker>): BackgroundJobPayloadForPeriodicServiceNowChangeStatusTracker {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicServiceNowChangeStatusTracker.newInstance(<BackgroundJobPayloadForPeriodicServiceNowChangeStatusTracker> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicServiceNowChangeStatusTracker) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicServiceNowChangeStatusTracker.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicServiceNowChangeStatusTracker): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicServiceNowChangeStatusTracker.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
